@if (overtimeSnapshot(); as snapshot) {
@if (headline()) {
<p class="c-kv-row">{{ headline() }}</p>
}

@if (snapshot.regularHours > 0 || snapshot.ot1Hours > 0 || snapshot.ot2Hours > 0) {
<p class="c-kv-row">
    @if (snapshot.regularHours > 0) {
    <span class="c-tag context:neutral">{{ 'voyage.overtimeLevel.regular' | translate }}
        {{ snapshot.regularHours.toFixed(1) }}h</span>
    }
    @if (snapshot.ot1Hours > 0) {
    <span class="c-tag context:warning">{{ 'voyage.overtimeLevel.ot1' | translate }}
        {{ snapshot.ot1Hours.toFixed(1) }}h</span>
    }
    @if (snapshot.ot2Hours > 0) {
    <span class="c-tag context:error">{{ 'voyage.overtimeLevel.ot2' | translate }}
        {{ snapshot.ot2Hours.toFixed(1) }}h</span>
    }
</p>
}

@for (group of levelGroups(); track group.level) {
@for (entry of group.breakdown; track entry.reasonsLabel) {
<p class="c-kv-row">
    <span class="c-tag" [class.context:warning]="group.level === portOvertimeLevel.OT1"
        [class.context:error]="group.level === portOvertimeLevel.OT2">
        {{ 'voyage.overtimeLevel.' + group.level | translate }}
    </span>
    <span class="c-kv-row__value">{{ entry.hours.toFixed(1) }}h</span>
    <span>— {{ entry.reasonsLabel }}</span>
</p>
}
}

@if (snapshot.timezone) {
<p class="c-kv-row">
    <span class="fa-regular fa-clock" aria-hidden="true"></span>
    {{ 'voyage.overtimeTimezone' | translate: { timezone: snapshot.timezone } }}
</p>
}
}
